module.exports = __webpack_public_path__ + "img/inventory.5b20dc98.svg";